import {DroppingOddsReducer, ReducerFromState} from "../../../@types/reducers";
import {InstantDropLists} from "../../../@types/inputs";


export const getLastChanges = (state: ReducerFromState<DroppingOddsReducer>): InstantDropLists => state.odds.instants;

